import { SelectItem } from "primeng/api";
import { PostNewReceivableInvoiceStatus } from "../enums";

export class PostNewReceivableInvoiceStatusLookup {
    static getLookup(): SelectItem[] {
        return [
            { label: 'In-Active', value: PostNewReceivableInvoiceStatus.InActive },
            { label: 'Issue', value: PostNewReceivableInvoiceStatus.Issue },
            { label: 'Claim', value: PostNewReceivableInvoiceStatus.Claim },
            { label: 'Settlement', value: PostNewReceivableInvoiceStatus.Settlement },
            { label: 'Manual', value: PostNewReceivableInvoiceStatus.Manual },
        ];
    }
}